export default "https://assets.pclncdn.com/web/next-landing/6889411/_next/static/images/pcln-hp-hero-packages-da19e40cc242f780e91a8f3aeb3209b7.jpg";